"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const PriceVariantMapper = {
  small: {
    default: "price-small",
    strikethrough: "price-small-discount"
  },
  medium: {
    default: "price-medium",
    strikethrough: "price-medium-discount"
  },
  large: {
    default: "price-large",
    strikethrough: "price-large-discount"
  }
};
const getPriceVariant = (size, type) => {
  if (!PriceVariantMapper[size]) {
    throw new Error(`Invalid size: ${size}`);
  }
  if (!PriceVariantMapper[size][type]) {
    throw new Error(`Invalid variant: ${type}`);
  }
  return PriceVariantMapper[size][type];
};
exports.getPriceVariant = getPriceVariant;
